"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  CIRCLE: 'Circle',
  ELLIPSE: 'Ellipse',
  GROUP: 'Group',
  LAYER: 'Layer',
  LINE: 'Line',
  PATH: 'Path',
  POINTTEXT: 'PointText',
  RASTER: 'Raster',
  RECTANGLE: 'Rectangle',
  TOOL: 'Tool'
};
exports.default = _default;